/* DoodleBeast: sticky add-to-cart bar on mobile product pages */
(function(){
  function init(){
    var form=document.querySelector('product-form form[action*="/cart/add"]');
    var submit=form&&form.querySelector('[type=submit]');
    var info=document.querySelector('product-info')||document.querySelector('.product__info-container');
    if(!form||!submit||document.querySelector('.db-sticky'))return;
    var title=(document.querySelector('.product__title h1')||{}).textContent||document.title;
    var img=document.querySelector('.product__media img');
    var bar=document.createElement('div');
    bar.className='db-sticky';
    bar.innerHTML='<img class="db-sticky__img" alt="" src="'+(img?img.currentSrc||img.src:'')+'"><div class="db-sticky__info"><span class="db-sticky__title"></span><span class="db-sticky__price"></span><span class="db-sticky__variant"></span></div><button type="button" class="db-sticky__btn">In winkelwagen</button>';
    document.body.appendChild(bar);
    bar.querySelector('.db-sticky__title').textContent=title.trim();
    function sync(){
      var price=document.querySelector('.price__container .price-item--regular, .price__container .price-item--sale');
      bar.querySelector('.db-sticky__price').textContent=price?price.textContent.trim():'';
      var sel=[].map.call(document.querySelectorAll('variant-selects input[type=radio]:checked'),function(i){return (i.value||'').trim()}).filter(Boolean);
      bar.querySelector('.db-sticky__variant').textContent=sel.join(' · ');
      var b=bar.querySelector('.db-sticky__btn');
      b.disabled=submit.disabled; b.textContent=submit.disabled?'Uitverkocht':'In winkelwagen';
      var im=document.querySelector('.product__media-item.is-active img')||document.querySelector('.product__media img');
      if(im&&(im.currentSrc||im.src))bar.querySelector('.db-sticky__img').src=im.currentSrc||im.src;
    }
    sync();
    bar.querySelector('.db-sticky__btn').addEventListener('click',function(){submit.click();});
    document.addEventListener('change',sync,true);
    new MutationObserver(sync).observe(info||document.body,{childList:true,subtree:true,characterData:true});
    var footer=document.querySelector('.footer');
    var ticking=false;
    function check(){
      ticking=false;
      var show=window.innerWidth<990&&submit.getBoundingClientRect().bottom<0;
      if(show&&footer&&footer.getBoundingClientRect().top<window.innerHeight-80)show=false;
      bar.classList.toggle('is-visible',show);
      document.body.classList.toggle('db-sticky-on',show);
    }
    function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(check);}}
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    check();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
